<template>
    <iframe src="https://app.getbeamer.com/harnessgiving" class="container-height" width="100%" style="border: 0;padding: 0;margin: 0">
    </iframe>
</template>

<script>
  export default {
    name: 'Roadmap',
    metaInfo: {
      title: 'Roadmap',
    },
  };
</script>

